import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var BooksFill = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.837 12.3c.2.5-.1 1-.5 1.2l-21.665 8.4c-.2.1-.4.1-.6 0L4.297 17.4C2.9 17 2 15.8 2 14.3v-3.5c0-1.3.799-2.5 2.097-3L24.364 0h.6l16.373 5c.4.2.6.5.6 1 0 .4-.2.8-.6 1l-21.665 8.4c-.2.1-.4.1-.6 0L3.898 10.7v3.6c0 .6.4 1.1.899 1.2L19.273 20l21.366-8.3c.499-.2 1.098.1 1.198.6ZM5.295 30.5c.2.5-.1 1-.5 1.2-.499.2-.798.7-.798 1.2v3.5c0 .6.4 1.1.898 1.2L19.273 42l21.366-8.2c.499-.2.998.1 1.198.5.2.5-.1 1-.5 1.2l-21.665 8.4c-.2.1-.5.1-.699.1L4.296 39.5C2.9 39 2 37.8 2 36.4v-3.5c0-1.3.799-2.5 1.997-3 .499-.1 1.098.1 1.298.6Z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.295 19.4c.2.5 0 1-.5 1.2-.499.2-.798.7-.798 1.2v3.5c0 .6.4 1.1.898 1.2l14.477 4.4 21.366-8.2c.5-.2.999.1 1.198.5.2.5-.1 1-.499 1.2l-21.665 8.4c-.2.1-.4.1-.6 0L4.297 28.4C2.9 28 2 26.7 2 25.3v-3.5c0-1.3.799-2.5 1.997-3 .499-.1 1.098.1 1.298.6Z"
  }));
});
BooksFill.displayName = 'BooksFill';
BooksFill.defaultProps = {
  'aria-label': 'BooksFill'
};
export default BooksFill;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Web/BooksFill.js
// module id = 3104
// module chunks = 11